import React from 'react';
import { StyleSheet, View } from 'react-native';
import ProjectFeedFeedbackControl from '../feed/ProjectFeedFeedbackControl';
import { ProjectPaperFeedbackPanelProps } from './types';

export default function ProjectPaperFeedbackPanel({
    projectPaperContext,
    pending,
    onSetFeedback,
    onClearFeedback,
}: ProjectPaperFeedbackPanelProps) {
    return (
        <View style={styles.container} testID="project-paper-feedback-panel">
            <ProjectFeedFeedbackControl
                feedback={projectPaperContext.feedback}
                pending={pending}
                onSetFeedback={onSetFeedback}
                onClearFeedback={onClearFeedback}
                showHeader={false}
            />
        </View>
    );
}

const styles = StyleSheet.create({
    container: {
        marginBottom: 0,
        width: '100%',
    },
});
